module.exports = __webpack_public_path__ + "img/xinchou_banner.b0c5af77.png";